import { render } from "./PwInquiry.vue?vue&type=template&id=0d13e4de"
import script from "./PwInquiry.vue?vue&type=script&lang=js"
export * from "./PwInquiry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__